import { render, staticRenderFns } from "./dataTableLogSheet.vue?vue&type=template&id=24a68460&scoped=true"
import script from "./dataTableLogSheet.vue?vue&type=script&lang=js"
export * from "./dataTableLogSheet.vue?vue&type=script&lang=js"
import style0 from "./dataTableLogSheet.vue?vue&type=style&index=0&id=24a68460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a68460",
  null
  
)

export default component.exports